import mensajeError from "../../mensajes/MensajeError";
import { mensajeExitoso } from "../../mensajes/MensajeExitoso";

export default async function actualizarDireccion(direccion) {
    direccion.fax = "";
    direccion.telefonoEsParticular = 0;
    const settings = {
        method: "PUT",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(direccion)
    }

    try {
        await fetch("/api/direccion/actualizar", settings);
        mensajeExitoso("Actualizado exitosamente");
    }
    catch (err) {
        mensajeError(err.message);
    }
}